import { IActionBase } from "../models/root.interface";
import { BULK_API_RESPONSE, DELETE_API_RESPONSE } from "../actions/urlShortener.action";

export interface IUrlShortenerState {
    deleteResponse: any,
    bulkListResponse: any
}

const initialState: IUrlShortenerState = {
    deleteResponse: {},
    bulkListResponse: {}
};

function urlShortenerReducer(state: any = initialState, action: IActionBase): any {
    switch (action.type) {
        case DELETE_API_RESPONSE:
            return { ...state, deleteResponse: action.deleteResponse };
        case BULK_API_RESPONSE:
            return { ...state, bulkListResponse: action.response };
        default:
            return state;
    }
}


export default urlShortenerReducer;